<template>
  <div class="wrapper overflow-hidden">
      <!-- Content Header (Page header) -->
      <section class="content-header py-2" v-if="$route.path === '/'">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1>Panel de Control</h1>
            </div>
          </div>
        </div>
      </section>

      <!-- Main content -->
      <section class="content" v-if="$route.path === '/'">
        <div class="container-fluid">
          <!-- Resumen de Datos Importantes 
          <div class="row" id="resumen-dashboard">
            <div class="col-lg-3 col-6 mb-2">
              <div class="small-box bg-info mb-0">
                <div class="inner">
                  <transition name="fade" mode="out-in" class="h3-container">
                    <h3 :key="currentStat.value">{{ currentStat.value }}</h3>
                  </transition>
                  <p>Ventas {{ currentStat.label }}</p>
                </div>
                <div class="icon"><i class="fas fa-shopping-bag"></i></div>
              </div>
            </div>
            <div class="col-lg-3 col-6 mb-2">
              <div class="small-box bg-success mb-0">
                <div class="inner">
                  <transition name="fade" mode="out-in">
                    <h3 :key="currentPayment.value">{{ currentPayment.value }}</h3>
                  </transition>
                  <p>Pagos {{ currentPayment.label }}</p>
                </div>
                <div class="icon"><i class="fas fa-chart-line"></i></div>
              </div>
            </div>
            <div class="col-lg-3 col-6 mb-2">
              <div class="small-box bg-warning mb-0">
                <div class="inner">
                  <transition name="fade" mode="out-in">
                    <h3 :key="currentCredit.value">{{ currentCredit.value }}</h3>
                  </transition>
                  <p>{{ currentCredit.label }}</p>
                </div>
                <div class="icon"><i class="fas fa-clock"></i></div>
              </div>
            </div>
            <div class="col-lg-3 col-6 mb-2">
              <div class="small-box bg-danger mb-0">
                <div class="inner">
                  <transition name="fade" mode="out-in">
                    <h3 :key="currentStockAlert.value">{{ currentStockAlert.value }}</h3>
                  </transition>
                  <p>{{ currentStockAlert.label }}</p>
                </div>
                <div class="icon"><i class="fas fa-exclamation-triangle"></i></div>
              </div>
            </div>
          </div> -->

          <!-- Accesos Rápidos -->
          <div class="row mb-3" id="accesos-rapidos">
            <div class="col-md-3 col-6 mb-2 mb-md-0">
              <router-link to="/nuevaventa" class="btn btn-outline-primary btn-block p-2 btn-sm-custom">
                <i class="fas fa-cart-plus fa-lg mb-1"></i><br>Nueva Venta
              </router-link>
            </div>
            <div class="col-md-3 col-6 mb-2 mb-md-0">
              <router-link to="/verpagos" class="btn btn-outline-success btn-block p-2 btn-sm-custom">
                <i class="fas fa-hand-holding-usd fa-lg mb-1"></i><br>Cargar Pago
              </router-link>
            </div>
            <div class="col-md-3 col-6 mb-2 mb-md-0">
              <router-link to="/movform" class="btn btn-outline-info btn-block p-2 btn-sm-custom">
                <i class="fas fa-exchange-alt fa-lg mb-1"></i><br>Nuevo Movimiento
              </router-link>
            </div>
            <div class="col-md-3 col-6 mb-2 mb-md-0">
              <router-link to="/inventario" class="btn btn-outline-secondary btn-block p-2 btn-sm-custom">
                <i class="fas fa-boxes fa-lg mb-1"></i><br>Ver Inventarios
              </router-link>
            </div>
          </div>

          <div class="row">
            <!-- Últimas Ventas -->
            <div class="col-md-7">
              <div class="card card-primary card-outline mb-2" id="tabla-ultimas-ventas">
                <div class="card-header py-2 d-flex align-items-center">
                  <h3 class="card-title">Últimas Ventas Realizadas</h3>
                  <router-link to="/ventas" class="btn btn-xs btn-primary ml-auto">Ver todas</router-link>
                </div>
                <div class="card-body p-0 table-responsive" style="height: 250px;">
                  <table class="table table-sm table-striped table-valign-middle">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Cliente</th>
                        <th>Fecha</th>
                        <th>Total</th>
                        <th class="text-right">Acción</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="venta in ventas" :key="venta.id">
                        <td>#{{ venta.id }}</td>
                        <td>
                          <div class="text-truncate" style="max-width: 150px;">
                            {{ venta.cliente }}
                          </div>
                        </td>
                        <td>{{ venta.fecha }}</td>
                        <td><span class="badge badge-success">${{ venta.total }}</span></td>
                        <td class="text-right">
                          <router-link :to="'/ventas/' + venta.id" class="btn btn-xs btn-default">
                            <i class="fas fa-eye"></i>
                          </router-link>
                        </td>
                      </tr>
                      <tr v-if="ventas.length === 0">
                        <td colspan="5" class="text-center">No hay ventas recientes</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- Historial de Movimientos -->
            <div class="col-md-5">
              <div class="card card-info card-outline mb-2" id="historial-reciente">
                <div class="card-header py-2 d-flex align-items-center justify-content-between">
                  <h3 class="card-title">Últimos Movimientos</h3>
                  <router-link to="/movimientos" class="btn btn-xs btn-info ml-auto">Ver todos</router-link>
                </div>
                <div class="card-body p-0 table-responsive" style="height: 250px;">
                  <!-- Tabla Movimientos -->
                  <table class="table table-sm table-striped">
                    <thead>
                      <tr>
                        <th>Tipo</th>
                        <th>Ref</th>
                        <th>Fecha</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody v-if="movimientos.length">
                      <tr v-for="(mov, index) in movimientos" :key="index">
                        <td><span :class="'badge badge-' + mov.badge">{{ mov.tipo }}</span></td>
                        <td>{{ mov.ref }}</td>
                        <td>{{ mov.fecha }}</td>
                        <td class="text-right">
                          <router-link :to="'/movimientos/' + mov.tipo.toLowerCase() + '/' + mov.ref" class="btn btn-xs btn-default">
                            <i class="fas fa-eye"></i>
                          </router-link>
                        </td>
                      </tr>
                      <tr v-if="movimientos.length === 0">
                        <td colspan="4" class="text-center">No hay movimientos recientes</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- /.content-wrapper -->

</template>

<script>
import api from "@/services/api";
import { tutorial } from "@/plugins/tutorial";

export default {
  data() {
    return {
      statIndex: 0,
      paymentIndex: 0,
      creditIndex: 0,
      stockIndex: 0,
      chartIndex: 0,
      stats: [{ label: 'Cargando...', value: '...' }],
      payments: [{ label: 'Cargando...', value: '...' }],
      credits: [{ label: 'Cargando...', value: '...' }],
      stockAlerts: [{ label: 'Cargando...', value: '...' }],
      movimientos: [],
      ventas: [],
      charts: [{ label: 'Cargando...', creditos: [0, 0], pagos: [0, 0] }]
    }
  },
  computed: {
    currentStat() { return this.stats[this.statIndex]; },
    currentPayment() { return this.payments[this.paymentIndex]; },
    currentCredit() { return this.credits[this.creditIndex]; },
    currentStockAlert() { return this.stockAlerts[this.stockIndex]; },
    currentChart() { return this.charts[this.chartIndex]; },
    chartLabels() {
      const labels = {
        'Últimos 7 días': ['Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab', 'Dom'],
        'Últimos 15 días': ['Día 1', 'Día 4', 'Día 7', 'Día 10', 'Día 13', 'Día 15'],
        'Últimos 30 días': ['Día 1', 'Día 10', 'Día 20', 'Día 30'],
        'Últimos 90 días': ['Mes 1', 'Mes 2', 'Mes 3']
      };
      return labels[this.currentChart.label] || [];
    }
  },
  mounted() {
    this.fetchDashboardData().then(() => {
      tutorial.set(this.iniciarTutorial);
    });
    this.startStatCycle();
  },
  beforeUnmount() {
    tutorial.set(null);
  },
  methods: {
    async fetchDashboardData() {
      try {
        const response = await api.get('/dashboard');
        this.stats = response.data.stats;
        this.payments = response.data.payments;
        this.credits = response.data.credits;
        this.stockAlerts = response.data.stockAlerts;
        this.movimientos = response.data.movimientos;
        this.ventas = response.data.ultimasVentas || [];
        this.charts = response.data.charts;
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    },
    startStatCycle() {
      setInterval(() => {
        this.statIndex = (this.statIndex + 1) % this.stats.length;
      }, 3000);
      setInterval(() => {
        this.paymentIndex = (this.paymentIndex + 1) % this.payments.length;
      }, 3500);
      setInterval(() => {
        this.creditIndex = (this.creditIndex + 1) % this.credits.length;
      }, 4000);
      setInterval(() => {
        this.stockIndex = (this.stockIndex + 1) % this.stockAlerts.length;
      }, 4500);
      setInterval(() => {
        this.chartIndex = (this.chartIndex + 1) % this.charts.length;
      }, 6000);
    },
    getLinePath(dataArray) {
      if (!dataArray || dataArray.length < 2) return "M 0 40 L 100 40";
      
      const points = dataArray.map((v, i) => {
        const x = i * (100 / Math.max(1, dataArray.length - 1));
        const y = 40 - (v * 0.35);
        return `L ${x} ${y}`;
      });
      
      return `M 0 40 ${points.join(' ')} L 100 40 Z`;
    },
    iniciarTutorial() {
      const steps = [
        {
          element: '#resumen-dashboard',
          title: 'Resumen General',
          text: 'Aquí puedes ver un resumen rápido de ventas, pagos, créditos y alertas de stock. Los datos rotan automáticamente.',
          position: 'bottom'
        },
        {
          element: '#accesos-rapidos',
          title: 'Accesos Rápidos',
          text: 'Botones directos para las operaciones más comunes del sistema.',
          position: 'bottom'
        },
        {
          element: '#tabla-ultimas-ventas',
          title: 'Ventas Recientes',
          text: 'Listado detallado de las últimas transacciones realizadas en el sistema.',
          position: 'top'
        },
        {
          element: '#historial-reciente',
          title: 'Actividad Reciente',
          text: 'Cambia entre las últimas ventas y movimientos de inventario realizados.',
          position: 'left'
        }
      ];

      tutorial.start(steps);
    }
  },
  watch: {
    $route() {
      this.$nextTick(() => {
        if (window.jQuery) {
          window.jQuery('[data-widget="treeview"]').Treeview('init');
        }
      });
    }
  }
}
</script>

<style scoped>
.small-box { padding: 10px; }
.small-box .inner h3 { font-size: 1.6rem; margin-bottom: 2px; }
.small-box .inner p { font-size: 0.85rem; margin-bottom: 0; }
.small-box .icon { top: 5px; font-size: 40px; }

.fade-enter-active, .fade-leave-active { transition: opacity .5s; }
.fade-enter, .fade-leave-to { opacity: 0; }

.zoom-enter-active, .zoom-leave-active { transition: transform 0.4s ease, opacity 0.4s ease; }
.zoom-enter { transform: scale(0.8); opacity: 0; }
.zoom-leave-to { transform: scale(1.2); opacity: 0; }

.chart-svg {
  height: 140px;
  width: 100%;
  display: block;
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.chart-svg path { transition: d 0.6s cubic-bezier(0.4, 0, 0.2, 1); }

:global(html) { scroll-behavior: smooth; overflow-x: hidden; }

@media (max-width: 767.98px) {
  .btn-sm-custom { font-size: 0.75rem; }
  .btn-sm-custom i { font-size: 1rem !important; margin-bottom: 2px !important; }
}
</style>